module.exports = __webpack_public_path__ + "img/bg-2.5f167cb9.png";